import React, { useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { Capacitor } from "@capacitor/core";

// Anuncio de Google AdSense (bloque "in-feed"/display adaptable). El script
// de adsbygoogle NO va en public/index.html: se inyecta una sola vez recién
// cuando se monta el primer bloque. Así AdSense (incluidos los anuncios
// automáticos) nunca corre en pantallas sin contenido como login, carga o
// listas vacías. Cada página debe montar el anuncio solo cuando ya tiene
// contenido para mostrar.
//
// El slot es el bloque "Publicidad" de AdSense (se puede pisar con
// REACT_APP_ADSENSE_SLOT). Dentro de la app (AdSense no permite mostrarse
// en WebViews; ahí corresponde AdMob) no se renderiza nada.
export const ADSENSE_CLIENT = "ca-pub-1071137709595435";
const DEFAULT_SLOT = process.env.REACT_APP_ADSENSE_SLOT || "4470971891";

// La app de Android es un WebView propio (proyecto aparte) que carga
// notiline.com y expone `window.Android`; no usa Capacitor. AdSense no se
// puede mostrar dentro de apps, así que se chequean los dos casos.
const isInsideApp = () =>
  Capacitor.isNativePlatform() ||
  (typeof window !== "undefined" && typeof window.Android !== "undefined");

const SCRIPT_SRC = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${ADSENSE_CLIENT}`;

const loadAdSenseScript = () => {
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;
  const script = document.createElement("script");
  script.async = true;
  script.src = SCRIPT_SRC;
  script.crossOrigin = "anonymous";
  document.head.appendChild(script);
};

const GoogleAd = ({ slot = DEFAULT_SLOT, format = "auto", fullWidthResponsive = true, sx }) => {
  const pushedRef = useRef(false);
  const insRef = useRef(null);
  const enabled = Boolean(slot) && !isInsideApp();

  useEffect(() => {
    if (!enabled || pushedRef.current) return;
    // Un <ins> sin ancho (oculto o fuera del layout) hace fallar el push.
    if (!insRef.current || insRef.current.offsetWidth === 0) return;
    pushedRef.current = true;
    try {
      loadAdSenseScript();
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Error cargando anuncio de AdSense:", e);
    }
  }, [enabled]);

  if (!enabled) return null;

  return (
    <Box
      sx={{
        width: "100%",
        my: 2,
        overflow: "hidden",
        textAlign: "center",
        // Sin anuncio para mostrar, AdSense deja el hueco reservado: se oculta
        '& ins[data-ad-status="unfilled"]': { display: "none !important" },
        ...sx,
      }}
    >
      <ins
        ref={insRef}
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client={ADSENSE_CLIENT}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={fullWidthResponsive ? "true" : "false"}
      />
    </Box>
  );
};

export default GoogleAd;
